import { useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import RankingTable from '@/components/base/RankingTable';
import CategoryTabs from '@/components/base/CategoryTabs';
import { actresses, getActressesByCategory } from '@/mocks/actresses';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const initialSlug = slug || 'comprehensive';
  const [activeSlug, setActiveSlug] = useState(initialSlug);

  const activeCategory = useMemo(
    () => categories.find((c) => c.slug === activeSlug) || categories[0],
    [activeSlug],
  );

  const filteredActresses = useMemo(() => {
    const categoryActresses = getActressesByCategory(activeSlug);

    const scoreMap: Record<string, 'overallScore' | 'popularityScore' | 'boxOfficeScore' | 'actingScore'> = {
      comprehensive: 'overallScore',
      popularity: 'popularityScore',
      boxoffice: 'boxOfficeScore',
      acting: 'actingScore',
      newcomer: 'overallScore',
    };

    const scoreKey = scoreMap[activeSlug] || 'overallScore';
    return [...categoryActresses].sort((a, b) => b[scoreKey] - a[scoreKey]);
  }, [activeSlug]);

  const scoreMap: Record<string, 'overallScore' | 'popularityScore' | 'boxOfficeScore' | 'actingScore'> = {
    comprehensive: 'overallScore',
    popularity: 'popularityScore',
    boxoffice: 'boxOfficeScore',
    acting: 'actingScore',
    newcomer: 'overallScore',
  };

  return (
    <>
      <SchemaOrg type="WebPage" data={{
        name: `${activeCategory.name} - 女优排行榜`,
        url: `https://readdy.ai/category/${activeSlug}`,
        description: activeCategory.description,
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: activeCategory.name },
                ]}
              />
            </div>
          </div>

          <section className="w-full px-4 md:px-6 pt-2 pb-14 md:pb-20">
            <div className="max-w-6xl mx-auto">
              <div className="mb-8">
                <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 font-bold mb-3">
                  {activeCategory.name}
                </h1>
                <p className="text-sm text-foreground-600 max-w-2xl">
                  {activeCategory.description}
                </p>
              </div>

              <div className="mb-6">
                <CategoryTabs
                  categories={categories}
                  activeSlug={activeSlug}
                  onSelect={setActiveSlug}
                />
              </div>

              <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                {filteredActresses.length > 0 ? (
                  <RankingTable
                    actresses={filteredActresses}
                    scoreKey={scoreMap[activeSlug] || 'overallScore'}
                  />
                ) : (
                  <div className="text-center py-16">
                    <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center text-foreground-300">
                      <i className="ri-inbox-line text-3xl"></i>
                    </div>
                    <p className="text-foreground-500">暂无数据</p>
                  </div>
                )}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}